<template>
    <div class="container">
        <div class="tab-bar" :style="{'--left':lef,'--width':wid}">
            <p class="item" v-for="(item,index) of listArr" :key="index" @click='onHandleClick($event,index)' :class="{active:activeIndex==index}">{{item}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "EiTabBar",
    props: {
        listArr: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activeIndex: 0,
            lef: "0px",
            wid: "80px"
        }
    },
    methods: {
        onHandleClick({ target }, index) {
            const { width, left } = target.getBoundingClientRect();
            const { left: parentLeft } = target.parentNode.getBoundingClientRect();
            this.lef = left - 4 - parentLeft + "px";
            this.wid = width + "px";
            this.activeIndex = index;
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100vh;
    background-color: antiquewhite;
    display: flex;
    justify-content: center;
    align-items: center;
}

.tab-bar {
    display: flex;
    background-color: #fff;
    border-radius: 24px;
    position: relative;
    border: 4px solid #fff;
}

.tab-bar::before {
    position: absolute;
    content: "";
    width: var(--width);
    height: 100%;
    background-color: #5080ef;
    border-radius: 24px;
    left: var(--left);
    transition: all 0.4s ease-in-out;
}
.item {
    color: #5080ef;
    margin: 0;
    padding: 10px 20px;
    z-index: 10;
    cursor: pointer;
}
.active {
    color: #fff;
    transition: all 0.4s ease-in-out;
}
</style>
